"use client"

import { Button, Popover, Row, Select, SelectProps } from "antd"

import Title from "@/components/common/Typography/Title"
import InputAdult from "./InputAdult"
import InputChildren from "./InputChildren"
import InputInfant from "./InputInfant"
import { FC, forwardRef, useImperativeHandle, useState } from "react"
import { useAppSelector } from "@/lib/redux/hooks"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUsers } from "@fortawesome/free-solid-svg-icons"
import Text from "@/components/common/Typography/Text"
import { useTranslation } from "react-i18next"

type SelectPeopleProps = SelectProps
export type SelectPeopleRef = {
  open: () => void,
  close: () => void
}

const SelectPeople = forwardRef<SelectPeopleRef, SelectPeopleProps>((props, ref) => {
  const [open, setOpen] = useState<boolean>(false)
  const { t } = useTranslation()
  const inputAdult = useAppSelector(state => state.flight.inputAdult)
  const inputChildren = useAppSelector(state => state.flight.inputChildren)
  const inputInfant = useAppSelector(state => state.flight.inputInfant)

  useImperativeHandle(ref, () => {
    return {
      close() {
        setOpen(false)
      },
      open() {
        setOpen(true)
      },
    }
  }, [])

  return (
    <Popover
      open={open}
      onOpenChange={(p) => setOpen(p)}
      trigger={['click']}
      placement='bottomLeft'
      arrow={false}
      overlayClassName="flights__formsearch--passengers-popover"
      classNames={{ root: "flights__formsearch--passengers-popover" }}
      content={(
        <div className="flights__formsearch--passengers">
          <Title className="flights__formsearch--passengers-title" level={5} style={{ marginTop: 0 }}>{t("flight.number_passengers")}</Title>
          <InputAdult />
          <InputChildren />
          <InputInfant />
          <Row style={{ marginTop: '1.2rem' }}>
            <Button onClick={() => setOpen(false)} block type='primary'>{t("common.done")}</Button>
          </Row>
        </div>
      )}
    >
      <Select
        style={{ marginTop: 15 }}
        prefix={<Text type='secondary'><FontAwesomeIcon icon={faUsers} /></Text>}
        value={`${inputAdult} ${t("common.adult")}, ${inputChildren} ${t("common.child")}, ${inputInfant} ${t("common.infant")}`}
        // onClick={() => setOpen(rev => !rev)}
        open={false}
        className="home__searching--select-people"
        popupMatchSelectWidth={false}
        size='large'
        listHeight={400}
        labelRender={() => `${inputAdult} ${t("common.adult")}, ${inputChildren} ${t("common.child")}, ${inputInfant} ${t("common.infant")}`}
        options={[]}
        {...props}
      />
    </Popover>
  )
})

export default SelectPeople